var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 30,
    viewBox: "0 0 370.3 487.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c01639;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.26,183.43c0,138.35-171.28,294.63-178.89,301.44a9.71,9.71,0,0,1-12.66,0C171.5,479,0,337,0,183.43c-.06-2.82,0-5.65,0-8.48C2.88,75.55,85.75-2.74,185.14.07q4.25-.12,8.48,0C293,1.9,372.13,84,370.26,183.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "246.5 216.97 245.63 216.97 219.81 104.7 188.13 104.7 188.13 306.45 213.07 306.45 213.07 172.67 214.23 172.67 242.98 306.45 272.02 306.45 272.02 104.7 246.5 104.7 246.5 216.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.49,101c-24.56,0-39.21,15.22-39.21,38.64V269.77c0,23.12,12.87,38.05,38.94,38.05,24.35,0,37.47-17,37.47-39.8v-74.9H132.35v25.17h11.12v48.56c0,6.74-2.43,12.88-10,12.88-6.71,0-9.93-4.87-9.93-12.18V141.39c0-6.75,1.46-12.59,9.93-12.59,7,0,10,4.38,10,12v32.48h27.19v-35.4c0-21.66-13.46-36.88-37.17-36.88"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/Red.79510415834caa981a7f85b750ce4dfe.svg";
export { ForwardRef as ReactComponent };